import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { IOsaExecucaoFaseAtividadeModel } from './../../../../../models/osa-execucao-cronograma-model';
import { OsaExecucaoCronogramaService } from './../../../../../services/osa-execucao-cronograma.service';
import Swal from 'sweetalert2';
import { ModalCancelarComponent } from './../../../../../shared/components/modal-cancelar/modal-cancelar-component';
import { isNumber } from 'ngx-bootstrap/chronos/utils/type-checks';

@Component({
  selector: 'app-modal-atividade',
  templateUrl: './modal-atividade.component.html',
  styleUrls: ['./modal-atividade.component.scss']
})

export class ModalAtividadeComponent implements OnInit {
  public model: IOsaExecucaoFaseAtividadeModel = {} as IOsaExecucaoFaseAtividadeModel;
  public osaExecucaoFaseId: number;
  public novoRegistro = true;
  public titulo;
  public acao!: string;
  public editar: boolean = false;
  public valido: boolean = false
  public disableNome: boolean = false;
  public disabeQtdePlanejada: boolean = false;

  public form = new FormGroup({
    nome: new FormControl(null, Validators.required),
    quantidadeDiasPlan: new FormControl(null, Validators.required),
    quantidadeDiasExec: new FormControl(null, Validators.required)
  });

  constructor(
    public matDialog: MatDialog,
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    private dialogRef: MatDialogRef<ModalAtividadeComponent>,
    private cronogramaService: OsaExecucaoCronogramaService,
    @Inject(MAT_DIALOG_DATA) public data,

  ) {

    this.osaExecucaoFaseId = data.osaExecucaoFaseId;
    this.acao = data.acao;

    if (this.acao === 'editar') {
      this.titulo = 'Editar Atividade'
      this.editar = true;
      this.model = data?.element
    }
    else {
      this.editar = false;
      this.titulo = 'Inserir Atividade';
    }
  }

  async ngOnInit() {

    this.form.get('quantidadeDiasPlan')?.disable();

    if (this.editar) {
      this.form.patchValue(this.model);
      if (!!this.model?.atividadeId) {
        this.form.get('nome')?.disable();
      }
      else {
        this.form.get('nome')?.enable();
      }
    }
    else {
      this.form.get('nome')?.enable();
      this.form.get('quantidadeDiasPlan')?.setValue(0);
    }
  }

  public concluir() {
    if (this.form.invalid) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        text: 'Formulário Inválido',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
      this.valido = true;
      return;
    }
    if (this.titulo === 'Inserir Atividade') {

      const atividade = {
        id: 0,
        osaExecucaoFaseId: this.osaExecucaoFaseId,
        nome: this.form.get('nome').value,
        quantidadeDiasPlan: 0,
        quantidadeDiasExec: Number(this.form.get('quantidadeDiasExec').value),
        atividadeId: null
      } as IOsaExecucaoFaseAtividadeModel

      this.cronogramaService.inserirAtividade(atividade)
        .then((res) => {
          if (res.sucesso) {
            Swal.fire({
              toast: true,
              position: 'top-end',
              icon: 'success',
              text: res.mensagem.descricao,
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
            this.data.confirmou = true;
            this.dialogRef.close(this.data);
          }
          else {
            Swal.fire({
              toast: true,
              position: 'top-end',
              icon: 'error',
              text: res.mensagem.descricao,
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
          }
        })
        .catch((err) => {
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            text: err.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        })
    }
    if (this.titulo === "Editar Atividade") {
      this.cronogramaService.atualizarAtividade(
        {
          id: this.model.id,
          osaExecucaoFaseId: this.osaExecucaoFaseId,
          nome: this.form.get('nome').value,
          quantidadeDiasPlan: Number(this.form.get('quantidadeDiasPlan').value),
          quantidadeDiasExec: Number(this.form.get('quantidadeDiasExec').value),
          atividadeId: this.model?.atividadeId
        })
        .then((res) => {
          if (res.sucesso) {
            Swal.fire({
              toast: true,
              position: 'top-end',
              icon: 'success',
              text: res.mensagem.descricao,
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
            this.data.confirmou = true;
            this.dialogRef.close(this.data);
          }
          else {
            Swal.fire({
              toast: true,
              position: 'top-end',
              icon: 'error',
              text: res.mensagem.descricao,
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
          }
        }).catch((err) => {
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            text: err.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        })
    }
  }

  public cancelar() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { interno: true };
    this.matDialog.open(ModalCancelarComponent, dialogConfig).afterClosed();
  }

}
